module.exports = __webpack_public_path__ + "static/media/segment2.bb330ef3.png";